// Get Conutry 
document.addEventListener("DOMContentLoaded", function() {
    const elementAddress = document.querySelector('select#AddressCountryNew');
    const statesData = elementAddress.options[elementAddress.selectedIndex].getAttribute("data-provinces");
    const statesList = JSON.parse(statesData).map(stateArray => stateArray[0]);
    
    const provinces = document.querySelectorAll('select[id^="AddressProvince"]');
    provinces.forEach(province => {
      statesList.forEach(state => {
        var opt = document.createElement('option');
        opt.value = state;
        opt.innerHTML = state;
        province.appendChild(opt);
      });
    });
});  


// Toggle account menu
function slideToggle() {
    var trigger = document.getElementById('togglemenu');
    var menu = document.querySelector('[data-account-menu]')
    menu.classList.toggle('active-toggle');
    trigger.classList.toggle('menu-toggle'); 
} 